import { mergeWith } from 'lodash-es';
import { getBaseHref } from 'shared/framework/util/javascript';

declare const window: Record<string, unknown>;

export class JsonLoader<Type> {
    #merge = (defaultValues: Type, jsonValues: Partial<Type>): Type =>
        mergeWith(
            defaultValues,
            jsonValues,
            (defaultValue, jsonValue): unknown =>
                jsonValue === null || jsonValue === undefined
                    ? defaultValue
                    : undefined,
        );

    #fetchJson = async (filePath: string): Promise<Partial<Type>> => {
        try {
            const response = await fetch(getBaseHref() + filePath);

            return (await response.json()) as Partial<Type>;
        } catch (e: unknown) {
            console.error('Something went wrong loading a json file', e);
            return {};
        }
    };

    load = async (filePath: string, defaultValues: Type, debugName: string) => {
        const jsonValues: Partial<Type> = await this.#fetchJson(filePath);

        const merged = this.#merge(defaultValues, jsonValues);

        // Make accessible in console for easier debugging
        window[debugName] = merged;

        return merged;
    };
}
